import React from "react";
import { connect } from "react-redux";
import { getEmpresas, activarDesactivarEmpresa } from "../empresas/EmpresaService";
import "../../styles/Empresa.css";
import DocumentDialogContent from "./Empresa";
import EmpresaDatos from "../empresas/EmpresaDatos";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import Navbar from '../home/Navbar';
import { Modal, Button, Col, Container, Row } from "react-bootstrap";
import visibility from '../../styles/icons/visibility.svg';
import editIcon from '../../styles/icons/edit.svg';
import doNotdisturb from '../../styles/icons/do_not_disturb.svg';
import restore from '../../styles/icons/settings_backup_restore.svg';
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg';
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";



class Empresas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar nueva Empresa",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedEmpresa: {
        nombre: "",
        direccion: "",
        ruc: "",
        activo: true,
        id: "",
      },
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogDesactivarEmpresa: false,
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      loading: true,
      search: "",
      pageSize: 10
    };
    this.tableRef = React.createRef();
  }



  handleDialog = (value, mensaje = "") => {
    if (value === false) {
      if (mensaje !== "") {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  handleDialogVerDatos = (value) => {
    if (value === false) {
      this.fetchEmpresa(0, this.state.pageSize, ""); //Para actualizar la grilla
    }
    this.setState({
      dialogIsOpenVerDatos: value,
    });
  };

  handleDialogDesactivarEmpresa = (estadoDialogo) => {
    this.setState({
      dialogDesactivarEmpresa: estadoDialogo,
    });
  };

  handleNewEmpresa = () => {
    this.setState(
      {
        dialogTitle: "Registrar nueva Empresa",
        selectedEmpresa: {
          nombre: "",
          direccion: "",
          ruc: "",
          activo: true,
          id: "",
        },
        dialogType: "add",
        submitText: "Guardar",
        disabledInput: false,
      },
      () => {
        this.handleDialog(true);
      }
    );
  };

  handleDesactivarEmpresa = (empresa, estado) => {
    activarDesactivarEmpresa(empresa.id, estado)
      .then((resp) => {
        if(!resp.error){
          this.fetchEmpresa(0, this.state.pageSize, "");
          this.handleDialogDesactivarEmpresa(false);
          this.setState({
            mostrarMensajeFlash: true,
            mensajeFlash: resp.mensaje, 
          });
        }else{
          this.setState({
            mostrarMensajeFlash: true,
            mensajeFlash: "Ocurrio un error al realizar la operacion", 
            severity: 'danger'
          });
        }
      })
  }

  handleVerdatos = () => {
    this.setState(
      {
        dialogTitle: "Detalles Empresa",
        selectedEmpresa: {
          nombre: "",
          direccion: "",
          ruc: "",
          activo: true,
          id: "",
        },
        dialogType: "add",
        submitText: "Guardar",
        disabledInput: false,
      },
      () => {
        this.handleDialogVerDatos(true);
      }
    );
  };
      handlePageChange(newPage) {
        if (newPage >= 0 && newPage < this.state.totalPages) {
          this.setState({ page: newPage }, () => {
            this.fetchEmpresa(newPage, this.state.pageSize, "");
          });
        }
      }
      componentDidMount() {
        this.fetchEmpresa(0, this.state.pageSize, "");
      }
    
      handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < this.state.totalPages) {
          this.setState({ page: newPage }, () => {
            this.fetchEmpresa(this.state.page, this.state.pageSize, "");
          });
        }
      };
    
      handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        this.setState({ pageSize: newPageSize, page: 0 }, () => {
          this.fetchEmpresa(this.state.page, this.state.pageSize, "");
        });
      };
    
      renderPageNumbers() {
        const { page, totalPages } = this.state;
        const maxVisiblePages = 5; // Máximo de páginas visibles
    
        let pages = [];
    
        if (totalPages <= maxVisiblePages) {
          // Mostrar todas las páginas si son pocas
          for (let i = 0; i < totalPages; i++) {
            pages.push(
              <li
                key={i}
                className={`page-item ${page === i ? "active" : ""}`}
                onClick={() => this.handlePageChange(i)}
              >
                <a className="page-link" type="Button">{i + 1}</a>
              </li>
            );
          }
        } else {
          // Mostrar primeras páginas, últimas y cercanas a la actual
          const startPage = Math.max(0, page - 2);
          const endPage = Math.min(totalPages - 1, page + 2);
    
          // Agregar primera página
          if (startPage > 0) {
            pages.push(
              <li
                key={0}
                className={`page-item ${page === 0 ? "active" : ""}`}
                onClick={() => this.handlePageChange(0)}
              >
                <a className="page-link" type="Button">1</a>
              </li>
            );
            if (startPage > 1) {
              pages.push(
                <li key="start-ellipsis" className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            }
          }
    
          // Agregar páginas visibles
          for (let i = startPage; i <= endPage; i++) {
            pages.push(
              <li
                key={i}
                className={`page-item ${page === i ? "active" : ""}`}
                onClick={() => this.handlePageChange(i)}
              >
                <a className="page-link" type="Button">{i + 1}</a>
              </li>
            );
          }
    
          // Agregar última página
          if (endPage < totalPages - 1) {
            if (endPage < totalPages - 2) {
              pages.push(
                <li key="end-ellipsis" className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              );
            }
            pages.push(
              <li
                key={totalPages - 1}
                className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
                onClick={() => this.handlePageChange(totalPages - 1)}
              >
                <a className="page-link" type="Button">{totalPages}</a>
              </li>
            );
          }
        }
    
        return pages;
      }
    
      fetchEmpresa(page, pageSize, search) {
        this.setState({ loading: true });
        this.props.getEmpresas(page, pageSize, search).then(() => {
          this.setState({
            numeroPatronal: this.props.empresaData.empresas,
            page: this.props.empresaData.page,
            totalCount: this.props.empresaData.totalCount,
            totalPages: Math.ceil(
              this.props.empresaData.totalCount / pageSize
            ),
            loading: false,
          });
        });
      }
    
      handleSearchChange = (e) => {
        const searchValue = e.target.value;
        this.setState({ search: searchValue }, () => {
          this.fetchEmpresa(0, this.state.pageSize, this.state.search);
        });
      };

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={"success"}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash} />
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogIsOpen}
              onHide={this.handleDialog}
              backdrop="static"
              keyboard="false">
              <DocumentDialogContent
                empresa={this.state.selectedEmpresa}
                handleClose={this.handleDialog}
                type={this.state.dialogType}
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle={this.state.dialogTitle}
              />
            </Modal>
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogIsOpenVerDatos}
              onHide={this.handleDialogVerDatos}
              backdrop="static"
              keyboard="false">
              <EmpresaDatos
                empresa={this.state.selectedEmpresa}
                handleClose={this.handleDialogVerDatos}
                type={this.state.dialogType}
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle={this.state.dialogTitle}
              />
            </Modal>

            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogDesactivarEmpresa}
              onHide={() => this.handleDialogDesactivarEmpresa(false)}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <img src={ExclamacionIcon} style={{ margin: '40px' }}></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      {
                        this.state.selectedEmpresa.activo
                          ?
                          <p><strong>Estas seguro que desea desactivar la empresa seleccionada?</strong></p>
                          :
                          <p><strong>Estas seguro que desea reactivar la empresa seleccionada?</strong></p>
                      }
                    </Col>
                  </Row>
                  <Row style={{ background: "#EDF2F9" }}>
                    <Col>
                      <p><strong>Empresa:</strong> {this.state.selectedEmpresa.nombre}</p>
                      <p><strong>RUC:</strong> {this.state.selectedEmpresa.ruc}</p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.handleDialogDesactivarEmpresa(false)} variant="contained">Cancelar</Button>
                  <Button onClick={() => this.handleDesactivarEmpresa(this.state.selectedEmpresa, !this.state.selectedEmpresa.activo)} color="primary" autoFocus>
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Container>
            </Modal>

            <div className="sectionHeader">
              <h1 className="pageTitle"> Empresas  </h1>
              <div className="actions">
                <Button
                  color="primary"
                  onClick={this.handleNewEmpresa}
                >
                  Nueva Empresa
                </Button>
              </div>
            </div>
            <Navbar
              menuActual={window.location.hash}
              seccionActual={'administracion'}
            />
          <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
            <div className="contentPage card" style={{ padding: "0px" }}>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Nombre</th>
                      <th scope="col">Direccion</th>
                      <th scope="col">RUC</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.empresaData.empresas.map((empresa, index) => (
                      <tr key={index}>
                        <th scope="row">{empresa.nombre}</th>
                        <td>{empresa.direccion}</td>
                        <td>{empresa.ruc}</td>
                        <td>{empresa.activo}</td>
                        <td>
                          <div className="table-actions">
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Editar Empresa",
                        selectedEmpresa: empresa,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialog(true);
                      });
                    }}>
                          <img src={editIcon} />
                          </a>
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Detalles Empresa",
                        selectedEmpresa: empresa,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialogVerDatos(true);
                      });
                    }}>
                          <img src={visibility} />
                          </a>
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: empresa.activo ? "Desactivar empresa" : "Reactivar empresa",
                        selectedEmpresa: empresa,
                        dialogType: "edit",
                        submitText: "Aceptar",
                        disabledInput: false
                      }, () => {
                        this.handleDialogDesactivarEmpresa(true);
                      });
                    }}>
                         {empresa.activo ? <img src={doNotdisturb} alt="" /> : <img src={restore} alt="" />}
                          </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getEmpresas: (page, size, search) => dispatch(getEmpresas(page, size, search)),
});

const mapStateToProps = (state) => ({
  empresaData: state.empresaData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Empresas);
